import {
  CModal,
  CModalHeader,
  CModalBody,
  CModalFooter,
  CButton,
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
  CAlert,
  CCol,
  CFormInput,
  CLoadingButton,
  CRow,
} from '@coreui/react-pro'

import Bootbox from 'bootbox-react'
import React, { useState, useEffect } from 'react'
import ToastComponent from 'src/components/common/TaostComponent'
import Tesseract from 'tesseract.js'
import CommonService from 'src/service/CommonService'
import PlayerService from 'src/service/PlayerService'
import { useParams } from 'react-router-dom'
import TeamPlayerService from 'src/service/TeamPlayerService'

const ImportPlayerSquad = (props) => {
  const urlParams = useParams()
  const [file, setFile] = useState(null)
  const [namesArray, setNamesArray] = useState([])
  const [gameType, setGameType] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessages, setErrorMessages] = useState([])
  const [showPrompt, setShowPrompt] = useState(false)
  const [foundPlayers, setFoundPlayers] = useState([])
  const [promptMessage, setPromptMessage] = useState('')
  const [similarPlayers, setSimilarPlayers] = useState([])
  const [similarMapping, setSimilarMapping] = useState({})
  const [notFoundPlayers, setNotFoundPlayers] = useState([])
  const [notFoundMapping, setNotFoundMapping] = useState({})
  const [mappingErrors, setMappingErrors] = useState({})

  useEffect(() => {
    CommonService.getGameType().then((res) => {
      if (res.status === 200) {
        setGameType(res.data)
      }
    })
  }, [])
  const [options, setOptions] = useState([])
  useEffect(() => {
    TeamPlayerService.teamPlayerListing(urlParams.fixtureId, urlParams.teamId).then((result) => {
      setOptions(result.data)
    })
  }, [urlParams.fixtureId])

  // Trigger API call when OCR namesArray is updated
  useEffect(() => {
    if (namesArray.length > 0 && gameType != null) {
      const payload = { players: namesArray, fixtureId: props.fixtureId, teamId: props.teamId }

      const handleResponse = (res) => {
        setIsLoading(false)
        if (res.success) {
          setFoundPlayers(res.found_players_detail || [])
          setPromptMessage(res.prompt_message1 || '')
          setSimilarPlayers(res.similar_found_names || [])
          setNotFoundPlayers(res.not_found_names || [])
          setShowPrompt(true)
          props.setPickedPlayer(res.picked_player)
          ToastComponent(res.message, 'success')
          setErrorMessages([])
        } else {
          const errors =
            res.errors && Array.isArray(res.errors)
              ? res.errors
              : [res.message || 'Something went wrong.']

          setErrorMessages(errors)
        }
      }

      // API call
      PlayerService.importPlayerFromImage(payload).then(handleResponse)
    }
  }, [namesArray, gameType])

  // Handle image file selection
  const handleOnChange = (e) => {
    setFile(e.target.files[0])
  }

  // Extract text from image using Tesseract
  const extractTextFromImage = async () => {
    if (!file) {
      ToastComponent('Please upload an image.', 'error')
      return
    }

    setIsLoading(true)
    setErrorMessages([])

    try {
      const result = await Tesseract.recognize(file, 'eng')
      let rawText = result.data.text || ''

      const normalize = (text) => {
        // unify newlines, preserve them, and collapse multiple spaces/tabs but NOT newlines
        const unifiedNewlines = text.replace(/\r\n|\r/g, '\n')
        return unifiedNewlines
          .replace(/[ \t]+/g, ' ') // collapse spaces/tabs to single space (keeps newlines)
          .replace(/’|‘|`/g, "'") // normalize fancy apostrophes
          .trim()
      }

      let cleanedText = normalize(rawText)

      let rawNames = []

      if (cleanedText.includes(',')) {
        // COMMA MODE: replace newlines with space so an OCR line-break inside a name doesn't split it
        const oneLine = cleanedText.replace(/\n+/g, ' ')
        rawNames = oneLine
          .split(',')
          .map((t) => t.trim())
          .filter((t) => t.length > 0)
      } else {
        // LIST MODE: split by newline (preserve each line as separate name)
        rawNames = cleanedText
          .split('\n')
          .map((t) => t.trim())
          .filter((t) => t.length > 0)
      }

      const names = rawNames.map((name) => ({ name }))

      if (names.length === 0) {
        setErrorMessages(['No names found in the image.'])
        setIsLoading(false)
        return
      }

      setNamesArray(names)
    } catch (error) {
      console.error(error)
      setErrorMessages(['Failed to read text from image.'])
      setIsLoading(false)
    }
  }

  const handlePromptOk = () => {
    setShowPrompt(false)
    props.setPickedPlayer(foundPlayers)
  }

  const hasMappingErrors = () => {
    return Object.values(mappingErrors).some((err) => err && err.length > 0)
  }

  const addSimilarPlayer = () => {
    if (hasMappingErrors()) {
      ToastComponent('Please fix incorrect mappings before submitting.', 'error')
      return
    }
    const ids = Object.values(similarMapping)

    PlayerService.mapSimilarPlayers({
      fixtureId: props.fixtureId,
      teamId: props.teamId,
      playerId: ids,
    }).then((res) => {
      props.setPickedPlayer(res.picked_player)
      ToastComponent(res.message, 'success')
      setShowPrompt(false)
    })
  }

  const addNotFoundPlayers = () => {
    if (hasMappingErrors()) {
      console.log('inside errors')
      ToastComponent('Please fix incorrect mappings before submitting.', 'error')
      return
    }
    console.log('after errors')
    const ids = Object.values(notFoundMapping).filter((v) => v !== '')

    if (ids.length === 0) {
      ToastComponent('Please select players for all names.', 'error')
      return
    }
    PlayerService.mapSimilarPlayers({
      fixtureId: props.fixtureId,
      teamId: props.teamId,
      playerId: ids,
    }).then((res) => {
      props.setPickedPlayer(res.picked_player)
      ToastComponent(res.message, 'success')
      setShowPrompt(false)
    })
  }

  const validateDuplicateSelection = (currentKey, selectedValue, allMapping) => {
    // If selectedValue is empty → no error
    if (!selectedValue) return ''

    // Check if this value exists anywhere else
    const usedValues = Object.entries(allMapping)
      .filter(([key, val]) => key !== currentKey) // ignore itself
      .map(([key, val]) => val)

    if (usedValues.includes(selectedValue)) {
      return 'Incorrect mapping'
    }

    return ''
  }

  return (
    <>
      {/* <Bootbox
        show={showPrompt}
        type="alert"
        message={messageHtml}
        onSuccess={handlePromptOk}
        onClose={handlePromptOk}
      /> */}
      {errorMessages.length > 0 && (
        <div className="error-list">
          {errorMessages.map((err, i) => (
            <CAlert color="danger" key={i}>
              {err}
            </CAlert>
          ))}
        </div>
      )}

      <CRow>
        <CCol md={6}>
          <CFormInput type="file" accept="image/*" onChange={handleOnChange} />
        </CCol>

        <CCol md={6}>
          <CLoadingButton
            color="success"
            variant="outline"
            loading={isLoading}
            onClick={extractTextFromImage}
          >
            Extract & Add
          </CLoadingButton>
        </CCol>
      </CRow>

      <CModal visible={showPrompt} onClose={handlePromptOk} size="lg">
        <CModalHeader>
          <h5 className="modal-title">Import Summary</h5>
        </CModalHeader>

        <CModalBody>
          <p>
            <strong>Added: </strong>
            {promptMessage?.add_player}
            {', '}
            <strong>Not Found: </strong>
            {promptMessage?.not_found_names}
          </p>

          {/* Added Players Table */}
          {/* <h6 className="mt-3">Added Players</h6> */}
          <CTable bordered small>
            <CTableHead>
              <CTableRow>
                <CTableHeaderCell style={{ width: '60px' }}>#</CTableHeaderCell>
                <CTableHeaderCell style={{ width: '150px' }}>Players Added</CTableHeaderCell>
              </CTableRow>
            </CTableHead>

            <CTableBody>
              {foundPlayers.map((p, i) => (
                <CTableRow key={i}>
                  <CTableDataCell>{i + 1}</CTableDataCell>

                  <CTableDataCell
                    style={{
                      maxWidth: '150px',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                    title={p.name}
                  >
                    {p.name}
                  </CTableDataCell>
                </CTableRow>
              ))}
            </CTableBody>
          </CTable>

          {/* Similar Players */}
          <h6 className="mt-4">
            <strong> Similar Players Found:</strong> {similarPlayers.length}
          </h6>

          <CTable bordered>
            <CTableHead>
              <CTableRow>
                <CTableHeaderCell style={{ width: '50px' }}>#</CTableHeaderCell>
                <CTableHeaderCell>Record Foundasdasd</CTableHeaderCell>
                <CTableHeaderCell>Similar Match</CTableHeaderCell>
                <CTableHeaderCell>Map To Player</CTableHeaderCell>
              </CTableRow>
            </CTableHead>

            <CTableBody>
              {similarPlayers.map((item, i) => (
                <CTableRow key={i}>
                  <CTableDataCell>{i + 1}</CTableDataCell>

                  {/* OCR Name */}
                  <CTableDataCell>{item.input_name}</CTableDataCell>

                  {/* Best Matched Name */}
                  <CTableDataCell>{item.match_name}</CTableDataCell>

                  {/* Select box for manual mapping */}
                  <CTableDataCell>
                    <select
                      className={`form-select ${mappingErrors[item.id] ? 'is-invalid' : ''}`}
                      value={similarMapping[item.id] || ''}
                      onChange={(e) => {
                        const val = e.target.value

                        // update mapping
                        setSimilarMapping((prev) => ({ ...prev, [item.id]: val }))

                        // validate immediately
                        const err = validateDuplicateSelection(item.id, val, similarMapping)
                        setMappingErrors((prev) => ({ ...prev, [item.id]: err }))
                      }}
                    >
                      <option value="">Select Player</option>
                      {options.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                          {opt.text}
                        </option>
                      ))}
                    </select>

                    {mappingErrors[item.id] && (
                      <div className="invalid-feedback">{mappingErrors[item.id]}</div>
                    )}
                  </CTableDataCell>
                </CTableRow>
              ))}
              {similarPlayers.length > 0 && (
                <CTableRow>
                  <CTableDataCell colSpan={4} className="text-end">
                    <CButton color="primary" onClick={addSimilarPlayer}>
                      Submit
                    </CButton>
                  </CTableDataCell>
                </CTableRow>
              )}
            </CTableBody>
          </CTable>

          {/* Not Found Players */}
          <h6 className="mt-4">
            <strong> Not Players Found:</strong> {notFoundPlayers.length}
          </h6>

          <CTable bordered>
            <CTableHead>
              <CTableRow>
                <CTableHeaderCell style={{ width: '50px' }}>#</CTableHeaderCell>
                <CTableHeaderCell>Record Found</CTableHeaderCell>
                <CTableHeaderCell>Map To Player</CTableHeaderCell>
              </CTableRow>
            </CTableHead>

            <CTableBody>
              {notFoundPlayers.map((name, i) => (
                <CTableRow key={`nf-${i}`}>
                  <CTableDataCell>{i + 1}</CTableDataCell>

                  {/* OCR Name */}
                  <CTableDataCell>{name}</CTableDataCell>

                  {/* Best Matched Name */}

                  {/* Select box for manual mapping */}
                  <CTableDataCell>
                    <select
                      className={`form-select ${mappingErrors[name] ? 'is-invalid' : ''}`}
                      value={notFoundMapping[name] || ''}
                      onChange={(e) => {
                        const val = e.target.value

                        setNotFoundMapping((prev) => ({ ...prev, [name]: val }))

                        const err = validateDuplicateSelection(name, val, notFoundMapping)
                        setMappingErrors((prev) => ({ ...prev, [name]: err }))
                      }}
                    >
                      <option value="">Select Player</option>
                      {options.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                          {opt.text}
                        </option>
                      ))}
                    </select>

                    {mappingErrors[name] && (
                      <div className="invalid-feedback">{mappingErrors[name]}</div>
                    )}
                  </CTableDataCell>
                </CTableRow>
              ))}
              {notFoundPlayers.length > 0 && (
                <CTableRow>
                  <CTableDataCell colSpan={4} className="text-end">
                    <CButton color="primary" onClick={addNotFoundPlayers}>
                      Submit
                    </CButton>
                  </CTableDataCell>
                </CTableRow>
              )}
            </CTableBody>
          </CTable>
        </CModalBody>

        <CModalFooter>
          <CButton color="primary" onClick={handlePromptOk}>
            OK
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default ImportPlayerSquad
